import React, { useEffect, useState } from "react";
import StylingOptionsSelector from "./StylingOptionsSelector";
import PostSubmissionActionsPanel from "./PostSubmissionActionsPanel";
import FormLayoutPanel from "./FormLayoutPanel";
import { WorkspaceInstances } from "../formInstances";
import { FormProvider, useFluidForm } from "../../fluidComponents/fluidForm/FormContext";
import { useFormInstanceDispatch, useFormUpdatedListener } from "../../fluidComponents/fluidForm/FormInstance.service";
import ChatOptionsPanel from './ChatOptionsPanel';
function SubPanel({ title, children }) {
    return (React.createElement("div", { className: "mb-5 border border-gray-200 rounded-xl shadow-lg" },
        React.createElement("div", { className: "flex justify-between items-center p-3 bg-gradient-to-r from-gray-50 to-white rounded-t-xl" },
            React.createElement("h3", { className: "font-medium text-gray-700" }, title)),
        React.createElement("div", { className: "p-5" }, children)));
}
// Extracted render component
const InterfaceFormRenderer = () => {
    const form = useFluidForm();
    const [update, setUpdate] = useState(0);
    const currentStyling = form.getValue("globalStyles.0") || {};
    // const currentLayout = form.getValue("layout") as FormLayoutType || "form";
    const dispatch = useFormInstanceDispatch(WorkspaceInstances.styleConfig);
    useEffect(() => {
        form.onUpdated((data) => {
            setUpdate((update) => update + 1);
        });
        dispatch("onFormUpdated", form.getFormSubmission());
    }, [form]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLayoutPanel, { form: form }),
        React.createElement(ChatOptionsPanel, { form: form }),
        React.createElement(SubPanel, { title: "Styling Options" },
            React.createElement(StylingOptionsSelector, { styles: currentStyling, onStyleChange: (styles) => {
                    form.setValue("globalStyles.0", styles);
                } })),
        React.createElement(PostSubmissionActionsPanel, { form: form })));
};
export function InterfaceTabContent({ configRecord, onConfigRecordChange }) {
    useFormUpdatedListener(WorkspaceInstances.styleConfig, (event) => {
        handleStyleChange(event);
    });
    const handleStyleChange = (newStyleConfig) => {
        const updatedRecord = {
            ...configRecord,
            styleConfig: newStyleConfig
        };
        onConfigRecordChange(updatedRecord);
    };
    return (React.createElement("div", null,
        React.createElement(FormProvider, { formInstance: WorkspaceInstances.styleConfig },
            React.createElement(InterfaceFormRenderer, null))));
}
